import { Flex, Typography } from 'shared';
import { dateUtils } from 'shared_DEPRECATED/utils';

type CoachingSessionRecapHeaderProps = {
  submittedAt: string;
  subject: string;
  color: string;
};

export const CoachingSessionRecapHeader = ({
  subject,
  submittedAt,
  color,
}: CoachingSessionRecapHeaderProps) => {
  const dayOfMonth = dateUtils(submittedAt).date();
  const month = dateUtils.abbreviatedMonthName(submittedAt);

  return (
    <Flex gap={2}>
      <Flex flexDirection="column" w="12">
        <Typography
          fontWeight="medium"
          type="body"
          // @ts-ignore
          color={color}
          textAlign="center"
        >
          {dayOfMonth}
        </Typography>
        <Typography
          fontWeight="regular"
          type="small"
          // @ts-ignore
          color={color}
          textAlign="center"
        >
          {month}
        </Typography>
      </Flex>
      <Flex flexDirection="column">
        <Typography
          fontWeight="medium"
          type="body"
          // @ts-ignore
          color={color}
        >
          {subject}
        </Typography>
        <Typography
          fontWeight="regular"
          type="small"
          // @ts-ignore
          color={color}
        >
          Session recap
        </Typography>
      </Flex>
    </Flex>
  );
};
